@use "/src/styles/functions";

.container {
  display: flex;
  flex-direction: column;
  gap: functions.space(20);
}
